import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { ModalRoleEnum } from '../../enums/modal-role.enum';

@Component({
  selector: 'app-selecionar-status',
  templateUrl: './selecionar-status.component.html',
  styleUrls: ['./selecionar-status.component.scss'],
})
export class SelecionarStatusComponent {
  arrStatus: Array<string> = ['Fila', 'Preparo', 'Pronto', 'Entrega', 'Entregue'];

  constructor(
    private modalCtrl: ModalController
  ) { }

  selecionouStatus(status: string) {
    const dataClose = new SelecionarStatusDataClose(status);

    this.modalCtrl.dismiss(dataClose, ModalRoleEnum.CONFIRM);
  }

  cancel() {
    this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
  }
}

export class SelecionarStatusDataClose {
  constructor(public status: string) { }
}
